import "./scss/main.scss";
import Header from "./Components/Header";
import UpperSection from "./Components/UpperSection";
import MiddleSection from "./Components/MiddleSection";
import LowerSection from "./Components/LowerSection";
import Footer from "./Components/Footer";
function App() {
  return (
    <>
      <Header />
      <UpperSection />
      <MiddleSection />
      <LowerSection />
      <Footer />
    </>
  );
}

export default App;
